// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"007d8850","359":"9afcb1cc"}[chunkId] + ".chunk.js";
};